module.exports = __webpack_public_path__ + "646f533133c9fa9dc70237f597e5a890.svg";